import { render, staticRenderFns } from "./GeneralNewsFeedItem.vue?vue&type=template&id=3e9a261b&scoped=true&"
import script from "./GeneralNewsFeedItem.vue?vue&type=script&lang=js&"
export * from "./GeneralNewsFeedItem.vue?vue&type=script&lang=js&"
import style0 from "./GeneralNewsFeedItem.vue?vue&type=style&index=0&id=3e9a261b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9a261b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VFlex,VIcon,VImg,VSpacer})
